
/**
 * Gets the keys for an object.
 *
 * @return {Array} keys
 * @api private
 */

module.exports = Object.keys || function keys (obj){
  var arr = [];
  var has = Object.prototype.hasOwnProperty;

  for (var i in obj) {
    if (has.call(obj, i)) {
      arr.push(i);
    }
  }
  return arr;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/socket.io-client/~/engine.io-parser/lib/keys.js
 ** module id = 415
 ** module chunks = 0
 **/